import { cn, focusRing, focusRingOnBlue, thaiText, numText } from './base/cn';

export { cn, focusRing, focusRingOnBlue, thaiText, numText };

/** ring แบบ inset — ใช้ในแถวตารางและเซลล์ที่ไม่มีที่ให้ ring ยื่นออก */
export const focusRingInset =
  'outline-none focus-visible:shadow-[var(--focus-ring-inset)] focus-visible:relative focus-visible:z-[1]';

/** ring บนพื้นไลม์ (#A5CE44) — ต้องใช้ ring น้ำเงินเข้ม ไม่ใช่ขาว */
export const focusRingOnLime =
  'outline-none focus-visible:ring-[3px] focus-visible:ring-offset-2 focus-visible:ring-[var(--blue-900)] focus-visible:ring-offset-[var(--lime-400)]';

/** ความสูงของ control ในหลังบ้าน — แทน touchTarget 44px ของแอปมือถือ */
export const hitTable = 'min-h-[var(--hit-table)]';
export const hitControl = 'min-h-[var(--hit-control)]';
export const hitPrimary = 'min-h-[var(--hit-primary)]';

/** ข้อความในตาราง: 14px / 1.45 — ใช้กับข้อความบรรทัดเดียวเท่านั้น */
export const tableText =
  'font-[family-name:var(--font-thai)] text-[length:var(--text-table)] leading-[var(--leading-table)]';

/** ข้อความในฟอร์ม: 14–15px / 1.5 */
export const formText =
  'font-[family-name:var(--font-thai)] text-[length:var(--text-form)] leading-[var(--leading-form)]';
